import React from 'react';
import Avatar from '@mui/material/Avatar';
import useCurrentUserDetails from 'api/useCurrentUserDetails';
import { styled, SxProps } from '@mui/material/styles';
import { Blue } from '../../../themes/blue/colorPalette';

const VLAvatar = styled(Avatar)(({ onClick }) => ({
    backgroundColor: Blue[9],
    color: Blue[1],
    fontSize: '14px',
    fontWeight: '500',
    cursor: onClick ? 'pointer' : 'auto',
    width: '38px',
    height: '38px'
}));

type UserAvatarProps = {
    /**
     * Handle click events.
     * _Note: The cursor will switch to 'pointer' when this callback is provided._
     * */
    onClick?: React.MouseEventHandler<HTMLDivElement>,
    /** Override component styles */
    sx?: SxProps
};

/** Displays the initials of the currently logged in user. These are retrieved from the global redux state,
 *  and so this component must be contained within a suitable provider. */
const UserAvatar = ({ sx,  onClick }: UserAvatarProps) => {
    const { userDetails } = useCurrentUserDetails();

    return (
        <VLAvatar sx={sx} onClick={onClick}>
            <span style={{
                display: 'inline-block',
                verticalAlign: 'middle',
                lineHeight: 'normal'
            }}>
                { userDetails?.firstName?.charAt(0) ?? '?' }{ userDetails?.lastName?.charAt(0) }
            </span>
        </VLAvatar>
    );
};

export default UserAvatar;
